/* eslint-disable @typescript-eslint/no-explicit-any */

import { ErrorMessage } from '@entities/error';
import { SerializedError } from '@reduxjs/toolkit';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';

interface ReduxHttpErrorType {
  messageText: string;
  isSystem: boolean;
}

export const getReduxErrorMessage = (
  error: FetchBaseQueryError | SerializedError,
  requestFrom?: string,
): ReduxHttpErrorType => {
  if ('status' in error) {
    const errorData = error.data as {
      message: string;
      errorCode: string;
      statusCode: number;
      exceptionType: string;
      params: any;
    };
    // you can access all properties of `FetchBaseQueryError` here

    let messageText: string = '';

    if (errorData && 'errorCode' in errorData) {
      const enumErrorMessage =
        ErrorMessage[errorData.errorCode as keyof typeof ErrorMessage];

      if (errorData.errorCode === 'INTERNAL_ERROR') {
        if (requestFrom === 'deposit') {
          if (
            errorData?.params?.message &&
            errorData.params.message.includes('is less than minimal')
          ) {
            messageText = 'Deposit amount is less than minimal. Try a larger amount.';
          } else {
            messageText = 'Failed to create a deposit. Please try again.';
          }
        } else if (requestFrom === 'withdraw')
          messageText = 'Failed to create a withdraw. Please try again.';
        else messageText = enumErrorMessage;

        return { messageText, isSystem: true };
      }

      messageText = enumErrorMessage;
      return { messageText, isSystem: false };
    } else {
      messageText = 'error' in error ? error.error : '';
      return { messageText, isSystem: true };
    }
  } else {
    // you can access all properties of `SerializedError` here
    return { messageText: error.message ?? '', isSystem: true };
  }
};
